/**
 * Shared bits of "deciding" a sign-up request (converting or rejecting it).
 *
 * A request is decided once and never again: the API answers 409 when someone
 * else resolved it first. That is not a failure of this panel — the tray is
 * simply stale — so it is told apart from a genuine error and reported as
 * such, with the list refreshed so the operator sees the real state.
 */

import { HttpError } from '@/utils/httpClient';

/** Whether the failure is "somebody else already decided this request". */
export const isAlreadyDecided = (error: unknown): boolean =>
  error instanceof HttpError && error.status === 409;

/** Translation key describing a failed decision to the operator. */
export const decisionErrorKey = (error: unknown): string =>
  isAlreadyDecided(error)
    ? 'resources.signupRequests.notifications.already_decided'
    : 'resources.signupRequests.notifications.decision_failed';
